module.exports = __webpack_public_path__ + "media/images/flags/16/Tonga-eecfe96a307203f1d71f8980f370c655.png";